import React from 'react';
import { DataTable } from '@frontend/app/refresh-components/DataTableV2/Table';
import { GetMultipleShopifyStats_storeStats } from '../../queries/types/GetMultipleShopifyStats';

interface Props {
  data: GetMultipleShopifyStats_storeStats[];
}

const columns = [
  { accessorKey: 'storeName', header: 'Store', cell: ({ row }) => row.original.storeName },
  { accessorKey: 'conversions',
header: 'Conversions',
cell: ({ row }) => (
  <div className="text-right w-full">{row.original.conversions}</div>
  ) },
  {
    accessorKey: 'sales',
    header: 'Sales',
    cell: ({ row }) => (
      <div className="text-right w-full flex flex-col items-end">
        <span>
          $ {row.original.sales.toLocaleString()}
        </span>
        {row.original.currency !== 'USD' && (
          <span className="text-xs text-muted-foreground cursor-pointer">
            {row.original.salesBase.toLocaleString()} {row.original.currency}
          </span>
        )}
      </div>
    ),
  },
  {
    accessorKey: 'avgSale',
    header: 'Avg. Sale',
    cell: ({ row }) => (
      <div className="text-right w-full flex flex-col items-end">
        <span>
          $ {row.original.avgSale.toLocaleString()}
        </span>
        {row.original.currency !== 'USD' && (
          <span className="text-xs text-muted-foreground cursor-pointer">
            {row.original.avgSaleBase.toLocaleString()} {row.original.currency}
          </span>
        )}
      </div>
    ),
  },
  {
    accessorKey: 'payoutEarned',
    header: 'Commission Earned',
    cell: ({ row }) => (
      <div className="text-right w-full flex flex-col items-end">
        <span>
          $ {row.original.payoutEarned.toLocaleString()}
        </span>
        {row.original.currency !== 'USD' && (
          <span className="text-xs text-muted-foreground cursor-pointer">
            {row.original.payoutEarnedBase.toLocaleString()} {row.original.currency}
          </span>
        )}
      </div>
    ),
  },
];

export default function RefreshMultipleShopifyStoreStats({ data }: Props) {
  return (
    <div className="border-t border-l border-r rounded-lg">
      <DataTable
        columns={columns}
        data={data}
        enableColumnResizing={false}
        getRowId={(row) => `${row.storeName}-${row.currency}-${row.sales}`}
        className="min-w-[900px]"
      />
    </div>
  );
}
